import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'META_COMBUSTIVEL_MODELO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('metaCombustivelModeloForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'META_COMBUSTIVEL_MODELO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setFiltroPrincipal(filtro = {}) {
    return {
        type: 'META_COMBUSTIVEL_MODELO_PRINCIPAL_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setFiltroGestao(filtro = {}) {
    return {
        type: 'META_COMBUSTIVEL_MODELO_GESTAO_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setFiltroAnalise(filtro = {}) {
    return {
        type: 'META_COMBUSTIVEL_MODELO_ANALISE_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'META_COMBUSTIVEL_MODELO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'META_COMBUSTIVEL_MODELO_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/metaCombustivelModelo`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_MODELO_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaMedia(idMetaCombustivelModelo) {
	return (dispatch, getState) => {
	
		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/metaCombustivelMedia?id_meta_combustivel_modelo=${idMetaCombustivelModelo || 0}`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_MODELO_MEDIA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaConsulta(placa) {
	return (dispatch, getState) => {
	
		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/metaCombustivelMediaConsulta?id_usuario=${getState().auth.usuario ? getState().auth.usuario.id : null}&placa=${(placa || '').split('+').map(itemPlaca => (itemPlaca || '').trim()).filter(itemPlaca => itemPlaca)}`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_MODELO_CONSULTA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaLog(dataInicial, dataFinal) {
	return (dispatch, getState) => {
	
		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/metaCombustivelMediaLog?padrao=true
			&data_inicial=${dataInicial}
			&data_final=${dataFinal}`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_MODELO_CONSULTA_LOG_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function getListaRota() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'META_COMBUSTIVEL_MODELO_ROTA_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/metaCombustivelRota`).then(resp => {
			dispatch({
		        type: 'META_COMBUSTIVEL_MODELO_ROTA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvarMedia(registro) {
    return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/metaCombustivelMedia`, {
				...registro,
				peso_inicial: FormatUtils.formatarValorBanco(registro.peso_inicial, 0),
				peso_final: FormatUtils.formatarValorBanco(registro.peso_final, 0),
				media: FormatUtils.formatarValorBanco(registro.media, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getListaMedia(registro.id_meta_combustivel_modelo));
				dispatch(getLista());
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/metaCombustivelMedia`, {
				...registro,
				peso_inicial: FormatUtils.formatarValorBanco(registro.peso_inicial, 0),
				peso_final: FormatUtils.formatarValorBanco(registro.peso_final, 0),
				media: FormatUtils.formatarValorBanco(registro.media, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getListaMedia(registro.id_meta_combustivel_modelo));
				dispatch(getLista());
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function importar(tabela, registroModelo) {

    return async (dispatch, getState) => {

		let listaImportada = [];
		
		let cabecalho = tabela[0];
		if (cabecalho) {
			for (let j = 0; j < getState().metaCombustivelModelo.listaPeso.length; j++) {
				const peso = getState().metaCombustivelModelo.listaPeso[j];				
				
				for (let k = 0; k < getState().metaCombustivelModelo.listaRota.length; k++) {
					const rota = getState().metaCombustivelModelo.listaRota[k];

					const meta = getState().metaCombustivelModelo.listaMedia.filter(itemMeta => 
						itemMeta.id_meta_combustivel_rota == rota.id
						&& itemMeta.peso_inicial == peso.peso_inicial
						&& itemMeta.peso_final == peso.peso_final
					)[0];

					let registro = null;
					if (meta) {
						registro = {
							...meta
						};
					} else {
						registro = {
							id_meta_combustivel_modelo: registroModelo.id,
							id_meta_combustivel_rota: rota.id,
							peso_inicial: peso.peso_inicial,
							peso_final: peso.peso_final,
							media: 0
						};
					}

					let indexPeso = tabela.map(itemTabela => (itemTabela[0] || '').trim()).indexOf(`${peso.peso_inicial} - ${peso.peso_final}`);
					let indexRota = cabecalho.map(itemCabecalho => (itemCabecalho || '').trim()).indexOf(rota.nome);
					
					let itemImportado = indexPeso > 0 && indexRota > 0 && tabela[indexPeso] && tabela[indexPeso][indexRota] ? tabela[indexPeso][indexRota] : 0;

					listaImportada.push({
						...registro,
						media: String(itemImportado || '').replace(',', '.') || 0,
						id_usuario_inclusao: getState().auth.usuario.id,
						id_usuario_alteracao: getState().auth.usuario.id
					});
				}
			}
				
		}

		await axios.post(`${consts.API_URL}/metaCombustivelMedia/importar`, {
			lista: listaImportada
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getListaMedia(registroModelo.id));
			dispatch(getLista());
		}).catch(e => {
			setErroAPI(e);
		});
    };
}
